<div [ngClass]="{
  'prow': classrow === 'FIRST_CLASS',
  'prowtop': classrow === 'FIRST_CLASS' && (seatDiv2.code === '5'),
  'prowtop1': classrow === 'FIRST_CLASS' && (seatDiv2.code === '6'),
  'prowtop9': classrow === 'FIRST_CLASS' && (seatDiv2.code === '9'),
  'prowtop10': classrow === 'FIRST_CLASS' && (seatDiv2.code === '10'),
  'arow': classrow === 'AM_PLUS',
  'prrow': classrow === 'PREFERRED',
  'crow': classrow === 'COACH',
  'crowA': classrow === 'COACH' && (seatDiv2.code === '22'),
  'crowB': classrow === 'COACH' && (seatDiv2.code === '32'),
  'crowC': classrow === 'COACH' && (seatDiv2.code === '33'),
  'erow': classrow === 'EXIT_ROW',
  'erow2': classrow === 'EXIT_ROW' && (seatDiv2.code === '15')
}">

  <!-- SALIDA DE EMERGENCIA SEÑALAMIENTO -->
  <div *ngIf="classrow === 'EXIT_ROW' || (classrow === 'FIRST_CLASS' && (seatDiv2.code === '5'))" class="d-flex justify-content-between mb-1 align-items-center exit-banner"
   [ngClass]="{
    'positionP1801':airplane == 'P180' && (seatDiv2.code === '14'),
    'positionP1802':airplane == 'P180' && (seatDiv2.code === '15')
    }">
    <div class = "text-exit-row left-text" ><img src="/assets/images/exit-L.svg" alt="Salida Izquierda"> &nbsp; &nbsp; &nbsp; {{'seatReview.faresDesc.exitPlane' | translate}}</div>
    <div class = "text-exit-row right-text"> {{'seatReview.faresDesc.exitPlane' | translate}} &nbsp; &nbsp; &nbsp;  <img src="/assets/images/exit-R.svg"></div>
  </div>

  <!-- CONTENEDOR DE LOS ASIENTOS -->
  <div class="d-flex flex-row" *ngIf="seatDiv2 && seatDiv2.seats"
    [ngClass]="{
      'prowtop-row5': (airplane === 'P7878' && (seatDiv2.code === '5' || seatDiv2.code === '6')),
      'crow-row39': (airplane === 'P7879' && seatDiv2.code === '39'),
      'crow-row40': (airplane === 'P7879' && seatDiv2.code === '40'),
      'calinbnt34': (airplane === 'P7379' && seatDiv2.code === '34'),
      'prow-row1': (airplane === 'PE190' && seatDiv2.code === '1')
    }"
  >
    <span *ngIf="(airplane !== 'P7879') && (airplane !== 'PE190')" class="rownumber">{{seatDiv2.code}}</span>

    <span *ngIf="airplane === 'P7879' && classrow === 'FIRST_CLASS'" class="rownumber">{{seatDiv2.code}}</span>
    <span *ngIf="airplane === 'P7879' && classrow === 'FIRST_CLASS'" class="rownumber2">{{seatDiv2.code}}</span>
    <span *ngIf="airplane === 'P7879' && classrow !== 'FIRST_CLASS'" class="rownumber3">{{seatDiv2.code}}</span>
    <span *ngIf="airplane === 'P7879' && classrow !== 'FIRST_CLASS'" class="rownumber4">{{seatDiv2.code}}</span>

    <span *ngIf="airplane === 'P7878'" class="rownumber2">{{seatDiv2.code}}</span>

    <span *ngIf="airplane === 'PE190' && classrow === 'FIRST_CLASS'" class="rownumber">{{seatDiv2.code}}</span>
    <span *ngIf="airplane === 'PE190' && classrow !== 'FIRST_CLASS'" class="rownumber2">{{seatDiv2.code}}</span>
   <!-- <app-am-plane-letters
      [fareClass]="classrow"
      [letters]="columns"
      [airplane]="airplane"
    >
    </app-am-plane-letters> -->

    <app-am-seat-plane
      [airplane]="airplane"
      [classType]="classrow"
      [seatDiv3]="row"
      [index]="i"
  
      *ngFor="let row of seatDiv2.seats; index as i"
    ></app-am-seat-plane>
  </div>
</div>
